export default __webpack_public_path__ + "30ef8b7a6af81cee0cac8c047d3888b6.svg";